import { AppBar, Box, Divider, Toolbar, useMediaQuery } from '@mui/material';
import backLogo from 'assets/images/main-menu.svg';
import phoneLogo from 'assets/images/phone.svg';
import thriftyLog from 'assets/images/thrifty-logo.svg';
import { Location, Phone } from 'components/index';
import React from 'react';
import { useNavigate } from 'react-router';
import { getBranchLocation } from 'utils/localStorage';
import { useBranchContext } from 'context/BranchesContext';
interface DefaultNavbar {
  logo: string;
}
export const DefaultNavbar: React.FC<DefaultNavbar> = ({ logo }) => {
  const { kioskLocation } = useBranchContext();
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const navigate = useNavigate();
  return (
    <AppBar
      position="sticky"
      sx={{
        height: 'auto',
        minHeight: '65px',
        maxHeight: '65px',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '90%',
          margin: 'auto',
        }}
      >
        {logo && logo === 'home' ? (
          <img
            src={thriftyLog}
            className="back-btn"
            width={120}
            alt="back-button-logo"
          />
        ) : (
          <>
            <Box
              className="backToMenu"
              onClick={() =>
                navigate(`/?locationCode=${kioskLocation.Code.toLowerCase()}`, {
                  replace: true,
                })
              }
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '30%',
                justifyContent: 'space-between',
                cursor: 'pointer',
              }}
            >
              <img src={backLogo} className="back-btn" alt="back-button-logo" />
            </Box>
            <Box
              sx={{
                width: '30%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img
                src={thriftyLog}
                className="back-btn"
                width={120}
                alt="back-button-logo"
              />
            </Box>
          </>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '40%',
            justifyContent: 'end',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column-reverse',
            }}
          >
            <Phone
              number={
                kioskLocation ? kioskLocation.ContactNo : '+971 554963590'
              }
            />
            <Location
              href={kioskLocation ? kioskLocation.GoogleLocationURL : ''}
              name={
                kioskLocation ? kioskLocation.Name : 'Al Karama Main Office'
              }
              target="_blank"
            />
          </Box>
          {!isPortrait && (
            <>
              <Divider
                sx={{
                  backgroundColor: '#999999',
                  width: '1px',
                  height: '40px',
                  marginLeft: '10px',
                  marginRight: '10px',
                }}
              />
              <img
                src={phoneLogo}
                className="phone-logo"
                style={{ width: '10%' }}
                alt="Phone Logo"
              />
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
